module.exports = __webpack_public_path__ + "img/hear-page-play-icon.7bdfd47.svg";